import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import decode from "jwt-decode";
import { getStore } from "../utils/storage";
import * as types from "../store/mutation-types";

const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      name: "home",
      path: "/",
      component: () => import("../view/Home"),
      props: (route) => ({ query: route.query.add }),
      meta: {
        title: "优秀的化学搜索网站",
      },
    },

    {
      name: "listview",
      path: "/listview/",
      component: () => import("../view/ListView"),
      children: [
        {
          // 当 /user/:id/profile 匹配成功，
          // UserProfile 会被渲染在 User 的 <router-view> 中
          path: "mole",
          component: () => import("../components/MoleList"),
          meta: {
            requiresAuth: true,
            title: "分子搜索结果",
          },
        },
        {
          // 当 /user/:id/posts 匹配成功
          // UserPosts 会被渲染在 User 的 <router-view> 中
          path: "crystal",
          component: () => import("../components/CrystalList"),
          meta: {
            requiresAuth: true,
            title: "晶体搜索结果",
          },
        },
      ],
    },
    {
      name: "reaction_list",
      path: "/reaction_list",
      component: () => import("../view/ReactionList"),
      meta: {
        requiresAuth: true,
        title: "化学反应搜索结果",
      },
    },
    {
      name: "detail",
      path: "/detail",
      component: () => import("../view/Detail"),
      props: (route) => ({ query: route.query.id }),
      meta: {
        requiresAuth: true,
        title: "详情显示页",
      },
    },
    {
      name: "reaction_detail",
      path: "/reaction_detail",
      component: () => import("../view/ReactionDetail"),
      props: (route) => ({
        query: {
          smilesId: route.query.smilesId,
          type: route.query.type,
          str: route.query.str,
          yield: route.query.yield,
        },
      }),
      meta: {
        requiresAuth: true,
        title: "化学反应信息详情显示页",
      },
    },
    {
      name: "find_password",
      path: "/find_password",
      component: () => import("../view/FindPassword"),
      meta: {
        title: "忘记密码",
      },
    },
    {
      name: "message_center",
      path: "/message_center",
      component: () => import("../view/MessageCenter"),
    },
    {
      path: "/personal_center",
      component: () => import("../view/PersonalCenter"),
      meta: {
        requiresAuth: true,
        title: "个人中心",
      },
    },
    {
      path: "/personal_info",
      component: () => import("../view/PersonalInformation"),
      meta: {
        title: "邮箱链接内容",
      },
    },
    {
      path: "/author",
      component: () => import("../view/Author"),
      meta: {
        title: "授权页面",
      },
    },
    {
      path: "/purchaseAgreement",
      component: () => import("../view/purchaseAgreement"),
      meta: {
        requiresAuth: true,
        title: "用户购买协议",
      },
    },
    {
      path: "/service",
      component: () => import("../view/Service"),
      meta: {
        title: "服务协议",
      },
    },
    {
      path: "/change_password",
      component: () => import("../view/ChangePassword"),
      meta: {
        requiresAuth: true,
        title: "密码重设",
      },
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

/**
 * 1. 检查即将进入的路由是否需要权限 若需要,检查是否登录,已登录,则进入;未登录,返回登录页
 * 2. 如果发现即将进入登录或注册页, 如果已登录,则注销;未登录,直接进入
 * 3. 如果两种都不时,直接进入路由
 */

export default router;

router.beforeEach((to, from, next) => {
  if (from.path === "/personal_info") {
    window.sessionStorage.removeItem("accessToken");
  }
  if (to.meta.title) {
    document.title = "大材库-" + to.meta.title;
  }
  next();
  let listwhat = window.localStorage.getItem("listwhat");
  store.commit("SET_LISTWHAT", listwhat);
  let isSignIn = window.localStorage.getItem("isSignIn");
  store.commit("SET_SIGN_IN", JSON.parse(isSignIn));
  next();

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (JSON.parse(isSignIn)) {
      next();
    } else {
      store.commit(types.SET_SNACK_INFO, {
        status: true,
        color: "error",
        msg: "Please log in and use it",
        timeout: 3000,
      });
      next("/");
    }
  } else {
    next();
  }
});
